import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../ui/button/button";
import { AUDIT_CTA } from "../../../lib/landingContent";
import "./audit.css";

const AuditSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="audit-section" id="audit">
      <div className="audit-inner">
        <p className="audit-kicker">AI BRAND AUDIT</p>
        <h2 className="audit-title">{AUDIT_CTA.title}</h2>
        <p className="audit-description">{AUDIT_CTA.description}</p>

        <div className="audit-actions">
          <Button
            variant="primary"
            size="md"
            className="btn-audit-primary"
            onClick={() => navigate("/audit?type=web")}
          >
            {AUDIT_CTA.buttonText}
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="btn-audit-outline"
            onClick={() => navigate("/audit?type=social")}
          >
            {AUDIT_CTA.secondaryButtonText}
          </Button>
                                                        
        </div>
        <div className="audit-disclaimer">
  <span>One-time report</span>
  <span>Instant delivery</span>
  <span>No subscription required</span>
</div>
      </div>
    </section>
  );
};

export default AuditSection;
